import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconChevronsUpDown: OSKIconDefinition = {
  name: 'chevrons-up-down',
  content: '<path d="m7 15 5 5 5-5" /><path d="m7 9 5-5 5 5" />'
};
